import React, { useEffect, useState } from 'react';
import ModalConnect from './modals/ModalConnect';
import ModalForgotPwd from './modals/ModalForgotPwd';
import ModalSignIn from './modals/ModalSignIn';
import ModalSocketError from './modals/ModalSocketError';

const Modal = (props) => {
    const { session, locale } = props;
    const [modal, setModal] = useState('ModalConnect');
    useEffect(() => {
        //
    }, [modal]);
    return (
        <>
            <div
                className="modal"
                id="modal"
                data-backdrop="static"
                data-keyboard="false"
                tabIndex="-1"
                aria-labelledby="modalTitle"
                aria-hidden="true"
            >
                {
                    modal === 'ModalConnect' ? <ModalConnect setModal={setModal} session={session} locale={locale} /> :
                        modal === 'ModalForgotPwd' ? <ModalForgotPwd setModal={setModal} session={session} locale={locale} /> :
                            modal === 'ModalSignIn' ? <ModalSignIn setModal={setModal} session={session} locale={locale} /> :
                                ''
                }
            </div>
            <ModalSocketError locale={locale} />
        </>
    );
};

export default Modal;
